<template>
  <div class="form-group">
    <slot>
      <button :value="value" :class="_class" v-bind="$attrs" v-on="listeners">{{value}}</button>
    </slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "ttw-button",
  props: {
    value: {
      type: [String, Number],
      description: "value"
    },
    _class:{
      type: [String],
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
  data() {
    return {
      focused: false
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus
      };
    }
  },
  methods: {
    onInput(evt) {
      this.$emit("input", evt.target.value);
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    }
  }
};
</script>
